export default __webpack_public_path__ + "static/dust2-ico-0ea10d5e8121098742f52b5b1407ba64.png";